export default __webpack_public_path__ + "static/media/logo.02951d0c.png";